import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const supportFormUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.contact_us}`;

// Login user function
export const submitSuppotForm = async (formData) => {
  try {
    const response = await axios.post(supportFormUrl, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response; // Return the response containing user and token
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An error occurred while Submiting form.";
    throw new Error(errorMessage);
  }
};
